import { render, staticRenderFns } from "./ArticleCategories.vue?vue&type=template&id=5895d288&scoped=true&"
import script from "./ArticleCategories.vue?vue&type=script&lang=js&"
export * from "./ArticleCategories.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCategories.vue?vue&type=style&index=0&id=5895d288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895d288",
  null
  
)

export default component.exports